import { Box, Typography, InputLabel } from "@mui/material";
import Personnummer from "personnummer";
import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { MyCheckbox } from "../../../../components/my-checkbox/MyCheckbox";
import { MyCountrySelect } from "../../../../components/my-country-select/MyCountrySelect";
import { MyNumberField } from "../../../../components/my-number-field/MyNumberField";
import { MyTextField } from "../../../../components/my-text-field/MyTextField";
import { EmailRegExp, PhoneNumberRegExp, ValidPostalRegExp, ValidTextRegExp } from "../../../../Constant";
import MyContext from "../../../../contexts/MyContext";
import { FormWrapper } from "../../FormWrapper";
import ClaimApiService from "../../../../adapters/xhr/ClaimApiService";
import { getConfirmation } from "../../../../components/my-confirmation-dialog/MyConfirmationDialog";
import { TrainTheme } from "../../../../infrastructure/TrainThemeProvider";
import { formatDepartureDate } from "../../../../Utils";

export const TicketForm3New = (props) => {
  const { t } = useTranslation();
  const myContext = useContext(MyContext);
  const [emailValueErr, setEmailValueErr] = useState("");
  const [emailConfirmValueErr, setEmailConfirmValueErr] = useState("");
  const [firstnameValueErr, setFirstnameValueErr] = useState("");
  const [surnameValueErr, setSurnameValueErr] = useState("");
  const [streetNameAndNumberValueErr, setStreetNameAndNumberValueErr] = useState("");
  const [postalCodeValueErr, setPostalCodeValueErr] = useState("");
  const [cityValueErr, setCityValueErr] = useState("");
  const [personalIDValueErr, setPersonalIDValueErr] = useState("");
  const [mobileNumberValueErr, setMobileNumberValueErr] = useState("");
  const [IBANValueErr, setIBANValueErr] = useState("");
  const [BICValueErr, setBICValueErr] = useState("");
  const [agreePersonalDataProcessingErr, setAgreePersonalDataProcessingErr] = useState("");

  const validate = async () => {
    let isValid = true;
    let validEmail = new RegExp(EmailRegExp);
    let validPhoneNumber = new RegExp(PhoneNumberRegExp);

    if (!myContext.email.trim()) {
      setEmailValueErr("required");
      isValid = false;
    } else if (!validEmail.test(myContext.email.trim())) {
      setEmailValueErr("invalid");
      isValid = false;
    } else {
      setEmailValueErr("");
    }

    if (!myContext.emailConfirm.trim()) {
      setEmailConfirmValueErr("required");
      isValid = false;
    } else if (myContext.email != myContext.emailConfirm) {
      setEmailConfirmValueErr("email_confirm_not_match");
      isValid = false;
    } else {
      setEmailConfirmValueErr("");
    }

    if (!myContext.firstname.trim()) {
      setFirstnameValueErr("required");
      isValid = false;
    } else setFirstnameValueErr("");
    if (!myContext.surname.trim()) {
      setSurnameValueErr("required");
      isValid = false;
    } else setSurnameValueErr("");

    if (myContext.hasPersonalID) {
      setIBANValueErr("");
      setBICValueErr("");
      if (!myContext.personalID) {
        setPersonalIDValueErr(t("required"));
        isValid = false;
      } else if (!Personnummer.valid(myContext.personalID)) {
        setPersonalIDValueErr("invalid");
        isValid = false;
      } else {
        const personNumber = Personnummer.parse(myContext.personalID);
        if (personNumber.century < 19) {
          setPersonalIDValueErr("invalid");
          isValid = false;
        } else setPersonalIDValueErr("");
      }
    } else {
      setPersonalIDValueErr("");
      if (!myContext.IBAN.trim()) {
        setIBANValueErr("required");
        isValid = false;
      } else setIBANValueErr("");
      if (!myContext.BIC.trim()) {
        setBICValueErr("required");
        isValid = false;
      } else setBICValueErr("");
    }

    if (!myContext.mobileNumber.trim()) {
      setMobileNumberValueErr("required");
      isValid = false;
    } else if (!validPhoneNumber.test(myContext.mobileNumber.trim())) {
      setMobileNumberValueErr("invalid");
      isValid = false;
    } else setMobileNumberValueErr("");

    if (isValid && !myContext.agreePersonalDataProcessing) {
      setAgreePersonalDataProcessingErr("agree_personal_data_processing_warning");
      isValid = false;
    } else {
      setAgreePersonalDataProcessingErr("");
    }

    if (isValid) myContext.changeActiveSlide((myContext.activeSlide += myContext.hasPersonalID ? 1 : 2));
  };

  return (
    <MyContext.Consumer>
      {(context) => (
        <React.Fragment>
          <FormWrapper onContinue={validate} heading={`${t("personal_info")}`}>
            <p id="required-description" className="margin bottom-0" style={{ marginTop: "0.5rem", width: "100%" }}>
              <Box component="small" color="error.main">
                *
              </Box>
              <small> {t("required_field")}</small>
            </p>
            <MyCheckbox
              className="margin top-1 bottom-0"
              label={t("no_personal_identifications_number")}
              checked={!context.hasPersonalID}
              onChange={(value) => {
                context.changePersonalID("");
                context.changehasPersonalID(!value);
              }}
            />
            <InputLabel hidden={!context.hasPersonalID} style={{ marginTop: "1.25rem", fontWeight: "bold", color: "#222", width: "100%" }} className="margin bottom-0" htmlFor="personalID">{`${t("personal_identifications_number")}`}</InputLabel>
            <MyNumberField
              hidden={!context.hasPersonalID}
              label={t("personal_identifications_number")}
              required={context.hasPersonalID}
              helperText={t(personalIDValueErr)}
              value={context.personalID}
              onChange={(e) => {
                context.changehasPersonalID(true);
                context.changePersonalID(e.target.value);
                context.changeIBAN("");
                context.changeBIC("");
              }}
              placeholder={t("personal_id_format")}
              format="########-####"
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  validate();
                }
              }}
            />
            {!context.hasPersonalID && (
              <>
               <InputLabel style={{ marginTop: "1.25rem", fontWeight: "bold", color: "#222", width: "100%" }} className="margin bottom-0" htmlFor="IBAN">{`${t("IBAN")}`}</InputLabel>
                <MyTextField required={true} value={context.IBAN} label={t("IBAN")} helperText={t(IBANValueErr)} onChange={context.changeIBAN} maxLength={34} />
                <InputLabel style={{ marginTop: "1.25rem", fontWeight: "bold", color: "#222", width: "100%" }} className="margin bottom-0" htmlFor="BIC">{`${t("BIC")}`}</InputLabel>
                <MyTextField required={true} value={context.BIC} label={t("BIC")} helperText={t(BICValueErr)} onChange={context.changeBIC} maxLength={11} />
              </>
            )}
            <InputLabel style={{ marginTop: "1.25rem", fontWeight: "bold", color: "#222", width: "100%" }} className="margin bottom-0" htmlFor="firstName">{`${t("firstname")}`}</InputLabel>
            <MyTextField
              required={true}
              value={context.firstname}
              label={t("firstname")}
              autoComplete="given-name"
              maxLength={40}
              helperText={t(firstnameValueErr)}
              onChange={context.changeFirstname}
              regExp={ValidTextRegExp}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  validate();
                }
              }}
            />
            <InputLabel style={{ marginTop: "1.25rem", fontWeight: "bold", color: "#222", width: "100%" }} className="margin bottom-0" htmlFor="surName">{`${t("surname")}`}</InputLabel>
            <MyTextField
              required={true}
              value={context.surname}
              regExp={ValidTextRegExp}
              label={t("surname")}
              autoComplete="family-name"
              maxLength={69}
              helperText={t(surnameValueErr)}
              onChange={context.changeSurname}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  validate();
                }
              }}
            />
            <InputLabel style={{ marginTop: "1.25rem", fontWeight: "bold", color: "#222", width: "100%" }} className="margin bottom-0" htmlFor="streetNameAndNumber">{`${t("street_name_and_number")}`}</InputLabel>
            <MyTextField
              value={context.streetNameAndNumber}
              regExp={ValidTextRegExp}
              label={t("street_name_and_number")}
              helperText={t(streetNameAndNumberValueErr)}
              onChange={context.changeStreetNameAndNumber}
              maxLength={35}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  validate();
                }
              }}
            />
            <InputLabel style={{ marginTop: "1.25rem", fontWeight: "bold", color: "#222", width: "100%" }} className="margin bottom-0" htmlFor="postalCode">{`${t("postal_code")}`}</InputLabel>
            <MyTextField
              value={context.postalCode}
              regExp={ValidPostalRegExp}
              label={t("postal_code")}
              helperText={t(postalCodeValueErr)}
              onChange={context.changePostalCode}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  validate();
                }
              }}
            />
            <InputLabel style={{ marginTop: "1.25rem", fontWeight: "bold", color: "#222", width: "100%" }} className="margin bottom-0" htmlFor="city">{`${t("city")}`}</InputLabel>
            <MyTextField
              value={context.city}
              regExp={ValidTextRegExp}
              label={t("city")}
              helperText={t(cityValueErr)}
              onChange={context.changeCity}
              maxLength={35}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  validate();
                }
              }}
            />
            <InputLabel style={{ marginTop: "1.25rem", fontWeight: "bold", color: "#222", width: "100%" }} className="margin bottom-0" htmlFor="country">{`${t("country")}`}</InputLabel>
            <MyCountrySelect label={t("country")} noOptionsText={t("no_options")} value={context.countryCode} onChange={(e, value) => context.changeCountryCode(value)} />
            <InputLabel style={{ marginTop: "1.25rem", fontWeight: "bold", color: "#222", width: "100%" }} className="margin bottom-0" htmlFor="mobileNumber">{`${t("mobile_number")}`}</InputLabel>
            <MyTextField
              maxLength={13}
              type="tel"
              required={true}
              autoComplete="tel-national"
              name="tel"
              value={context.mobileNumber}
              regExp={"^[ 0-9]{0,13}$"}
              label={t("mobile_number")}
              helperText={t(mobileNumberValueErr)}
              onChange={context.changeMobileNumber}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  validate();
                }
              }}
            />
            <InputLabel style={{ marginTop: "1.25rem", fontWeight: "bold", color: "#222", width: "100%" }} className="margin bottom-0" htmlFor="email">{`${t("email")}`}</InputLabel>
            <MyTextField
              required={true}
              value={context.email}
              regExp={ValidTextRegExp}
              label={t("email")}
              autoComplete="email"
              helperText={t(emailValueErr)}
              onChange={context.changeEmail}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  validate();
                }
              }}
            />
            <InputLabel style={{ marginTop: "1.25rem", fontWeight: "bold", color: "#222", width: "100%" }} className="margin bottom-0" htmlFor="confirmEmail">{`${t("confirm_email")}`}</InputLabel>
            <MyTextField
              required={true}
              value={context.emailConfirm}
              regExp={ValidTextRegExp}
              label={t("confirm_email")}
              autoComplete="email"
              helperText={t(emailConfirmValueErr)}
              onChange={context.changeEmailConfirm}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  validate();
                }
              }}
            />
            <MyCheckbox helperText={t(agreePersonalDataProcessingErr)} label={t("agree_personal_data_processing")} checked={context.agreePersonalDataProcessing} onChange={context.changeAgreePersonalDataProcessing} formControlStyle={{ marginTop: "0.5rem" }} />
            <Typography sx={{ flex: "1 1 100%", a: { color: "primary.main" } }} component="p" dangerouslySetInnerHTML={{ __html: t("contact_read_about_how_data_processed") }} />
          </FormWrapper>
        </React.Fragment>
      )}
    </MyContext.Consumer>
  );
};
